import React from 'react';

const Imprint: React.FC = () => {
  return (
    <div className="container mx-auto px-6 py-16 max-w-3xl">
      <h1 className="text-3xl font-medium mb-8">Imprint</h1>
      
      <div className="prose prose-lg">
        <p>Unless stated otherwise, all texts and content by Substans.</p>
        <p>Company: Objects Gallery LTD</p>
        <p>Registered in England and Wales.</p>
        <p className="mt-8">Website: Built using AI.</p>
        <p>©2025 Objects Gallery LTD. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Imprint;
